import "./outlet.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdmins, updateUser } from "../../redux/apiCalls";
import moment from "moment";
import Table from "../../components/advancedTable";
import Select from "react-select";

export default function Outlet() {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.user.products);
    const [filterCategory] = useState(undefined);
    const [isLoaded, setIsLoaded] = useState(false);
    const [outletData, setOutletData] = useState([]);
    const [admin, setAdmin] = useState(undefined);
    const [editModalState, setEditModalState] = useState(false);
    const [statusModalState, setStatusModalState] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState(undefined);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getAdmins(dispatch, filterCategory);
            if (res) {
                setOutletData(res || []);
                setIsLoaded(true);
            }
        };
        fetchData();
    }, [dispatch, filterCategory]);

    const handleChange = (e) => {
        setAdmin((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleChangeAddress = (e) => {
        setAdmin((prev) => {
            return {
                ...prev,
                address: { ...prev.address, [e.target.name]: e.target.value },
            };
        });
    };

    const handleClick = async () => {
        // Create a copy of the admin object
        const adminToUpdate = { ...admin };
        
        // Remove password field if it's empty, undefined, or not provided
        if (!adminToUpdate.password || adminToUpdate.password.trim() === '') {
            delete adminToUpdate.password;
        }
    
        updateUser(admin._id, adminToUpdate, dispatch);
    };

    const handleStatusChange = async (newStatus) => {
        const adminToUpdate = {
            ...selectedAdmin,
            status: newStatus,
        };
        
        // Remove password field
        delete adminToUpdate.password;
        
        await updateUser(selectedAdmin._id, adminToUpdate, dispatch);
        setStatusModalState(false);
        setIsLoaded(false);
    };

    const columns = [
        {
            accessor: "debtorCode",
            Header: "Prefix",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value : "-"}</div>
            ),
        },
        {
            accessor: "name",
            Header: "Name",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding font-medium">{value}</div>
            ),
        },
        {
            accessor: "phoneNumber",
            Header: "Phone Number",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value}</div>
            ),
        },
        {
            accessor: "email",
            Header: "Email",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value : "-"}</div>
            ),
        },
        {
            accessor: "type",
            Header: "Type",
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${
                        value === 'admin' ? 'bg-blue-100 text-blue-800' :
                        value === 'manager' ? 'bg-green-100 text-green-800' :
                        value === 'staff' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-gray-100 text-gray-800'
                    }`}>
                        {value}
                    </span>
                </div>
            ),
        },
        {
            accessor: "status",
            Header: "Status",
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${
                        value === 'active' ? 'bg-green-100 text-green-800' :
                        'bg-red-100 text-red-800'
                    }`}>
                        {value}
                    </span>
                </div>
            ),
        },
        {
            accessor: "createdAt",
            Header: "Member Since",
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "action",
            Header: "Action",
            width: 200,
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex items-center justify-center gap-2 whitespace-nowrap">
                        <button
                            className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-blue-500 whitespace-nowrap"
                            onClick={() => {
                                setAdmin(params.row.original);
                                window.scrollTo(0, 0);
                                setEditModalState(true);
                            }}
                        >
                            ✏️ Edit
                        </button>
                        <button
                            className="px-4 py-2 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-purple-500 whitespace-nowrap"
                            onClick={() => {
                                setSelectedAdmin(params.row.original);
                                window.scrollTo(0, 0);
                                setStatusModalState(true);
                            }}
                        >
                            🔄 Status
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
                <div className="productList bg-white rounded-3xl shadow-2xl p-8 m-6 border border-slate-200/50">
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold text-slate-800 mb-2">Outlet Management</h1>
                        <p className="text-slate-600">Manage your outlet partners and administrators</p>
                    </div>

                    {isLoaded && (
                        <Table
                            data={outletData}
                            columns={columns}
                            pageCount={Math.ceil(outletData.length / 999)}
                            totalCount={outletData.length}
                            updatePagination={() => {}}
                            paginationState={{ page: 1, limit: 999 }}
                            updateLoaded={() => {}}
                            hidePagination={outletData.length <= 999}
                        />
                    )}
                </div>
            </div>

            {editModalState && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-slate-200">
                        <div className="sticky top-0 bg-white rounded-t-2xl border-b border-slate-200 p-6 z-10">
                            <div className="flex justify-between items-center">
                                <h2 className="text-2xl font-bold text-slate-800">Edit Admin</h2>
                                <button
                                    onClick={() => setEditModalState(false)}
                                    className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6">
                            <form className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Full Name</label>
                                        <input
                                            name="name"
                                            type="text"
                                            placeholder={admin?.name || "Enter full name"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Username</label>
                                        <input
                                            name="email"
                                            type="string"
                                            placeholder={admin?.email || "Enter username"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Phone Number</label>
                                        <input
                                            name="phoneNumber"
                                            type="tel"
                                            placeholder={admin?.phoneNumber || "Enter phone number"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Debtor Code</label>
                                        <input
                                            name="debtorCode"
                                            type="text"
                                            placeholder={admin?.debtorCode || "Enter debtor code"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Password</label>
                                        <input
                                            name="password"
                                            type="password"
                                            placeholder="Enter new password"
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                </div>
                            
                                
                                <div className="flex justify-end gap-4 pt-6 border-t border-slate-200">
                                    <button
                                        type="button"
                                        onClick={() => setEditModalState(false)}
                                        className="px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-xl transition-colors duration-200"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleClick}
                                        className="px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105"
                                    >
                                        Update Admin
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {statusModalState && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                    onClick={() => setStatusModalState(false)}
                >
                    <div 
                        className="bg-white rounded-lg shadow-xl max-w-md w-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Status</h2>
                            
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Status
                                    </label>
                                    <Select
                                        options={[
                                            { label: "Active", value: "active" },
                                            { label: "Inactive", value: "inactive" },
                                        ]}
                                        onChange={(selectedOption) => {
                                            handleStatusChange(selectedOption.value);
                                        }}
                                        value={
                                            selectedAdmin?.status
                                                ? { 
                                                    label: selectedAdmin.status.charAt(0).toUpperCase() + selectedAdmin.status.slice(1), 
                                                    value: selectedAdmin.status 
                                                }
                                                : { label: "Active", value: "active" }
                                        }
                                        placeholder="Select Status"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderColor: '#d1d5db',
                                                borderRadius: '0.375rem',
                                                padding: '0.25rem',
                                                fontSize: '14px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#9ca3af',
                                                }
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected 
                                                    ? '#3b82f6' 
                                                    : state.isFocused 
                                                    ? '#dbeafe' 
                                                    : 'white',
                                                color: state.isSelected ? 'white' : '#374151',
                                                '&:hover': {
                                                    backgroundColor: state.isSelected ? '#3b82f6' : '#dbeafe',
                                                }
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                borderRadius: '0.375rem',
                                                marginTop: '4px',
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
